import store from '@/store/store.js'

export default feedItem => {
  return Object.assign({}, feedItem, {
    user: getUser(feedItem),
    device: getDevice(feedItem)
  })
}

const getUser = (feedItem) => {
  if (!feedItem.user_id) {
    return null
  }

  return store.getters['children/getById'](feedItem.user_id)
}

const getDevice = (feedItem) => {
  let child = store.getters['children/getById'](feedItem.user_id)

  if (!child || !feedItem.device_id || !child.devices) {
    return null
  }

  return child.devices.find(device => device.id === feedItem.device_id)
}
